
    import { PAYINHISTORY, PAYOUTHISTORY } from "./type"


    const initialState = {
        transactionStatuswithAmountPinBar :  [],
        transactionStatuswithAmountPoutBar: []
    
    }
    const setDashboardHistoryReducer = (state = initialState, action) => {
    
        switch (action.type) {
            case PAYINHISTORY:
                
                return {
                ...state,
                transactionStatuswithAmountPinBar:action.payload
                }
                case PAYOUTHISTORY:
                
                return {
                ...state,
                transactionStatuswithAmountPoutBar:action.payload
                }
            
            default:
                return state
        }
    }

    export default setDashboardHistoryReducer